import * as React from "react";
import { MessageSquareMore, MonitorSmartphone, CircleCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
const processSteps = [{
  num: "01",
  title: "Vision & Modeling",
  description: "We begin with high-fidelity 3D rendering and modeling to visualize your dream space before a single hammer swings.",
  icon: MessageSquareMore,
  badge: null,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/revit_floor_plan_modeling.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/revit_floor_plan_modeling.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/revit_floor_plan_modeling.png-wvc-sizes",
  alt: "Revit floor plan"
}, {
  num: "02",
  title: "Architectural Design",
  description: "Our craftsmen develop precise floor plans and structural designs tailored to your home's unique footprint and needs.",
  icon: MonitorSmartphone,
  badge: "Precision Planning",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/REndering.jpg",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/REndering.jpg-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/REndering.jpg-wvc-sizes",
  alt: "3D rendering of floor plan"
}, {
  num: "03",
  title: "The Master Craft",
  description: "From additions to whole-home remodels, our licensed team builds with uncompromising quality and high-end finishes.",
  icon: CircleCheck,
  badge: null,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/completed_luxury_home_remodel.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/completed_luxury_home_remodel.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1670428/img/completed_luxury_home_remodel.png-wvc-sizes",
  alt: "Completed project photo"
}];
export default function ThreeSimpleSteps() {
  return <section data-section-id="224508" id="from-concept-to-craft" className="bg-background text-foreground py-24 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <h2 className="text-3xl md:text-5xl font-default font-bold tracking-tight mb-6 text-primary">
            From Concept to Craft
          </h2>
          <p className="text-lg text-muted-foreground font-sans max-w-2xl mx-auto">
            Experience a seamless journey from initial floor plan design to the final reveal of your high-end residential transformation.
          </p>
        </div>

        <div className="relative">
          <div className="hidden md:block absolute top-[4.5rem] left-[16.66%] right-[16.66%] h-px border-t-2 border-dashed border-secondary/30 z-0" aria-hidden="true" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-12 relative z-10">
            {processSteps.map((step, index) => <Card key={step.num} data-index={index} className="relative overflow-hidden rounded-md border-border bg-card/50 backdrop-blur-sm shadow-md transition-all hover:bg-card hover:border-secondary/50 flex flex-col h-full">
                <span className="absolute -bottom-10 -right-6 text-[180px] font-bold leading-none text-secondary/5 select-none pointer-events-none z-0 font-sans tracking-tighter" aria-hidden="true">
                  {step.num}
                </span>

                <CardHeader className="relative z-10 pb-4 pt-8 px-8">
                  <div className="w-16 h-16 rounded-md bg-secondary/10 flex items-center justify-center mb-8 border border-secondary/20 shadow-sm">
                    <step.icon className="w-8 h-8 text-secondary" strokeWidth={1.5} />
                  </div>
                  
                  <div className="mb-6 overflow-hidden rounded-md border border-border shadow-sm">
                    <img src={step.image} data-wvc-srcset={step.srcset} data-wvc-sizes={step.sizes} alt={step.alt} className="w-full h-48 object-cover" loading="lazy" />
                  </div>

                  <div className="flex items-center justify-between gap-4 flex-wrap">
                    <CardTitle className="text-2xl font-default font-semibold text-card-foreground">
                      {step.title}
                    </CardTitle>
                    {step.badge && <Badge variant="default" className="rounded-md px-3 py-1 font-sans text-xs shadow-sm bg-secondary text-secondary-foreground">
                        {step.badge}
                      </Badge>}
                  </div>
                </CardHeader>
                
                <CardContent className="relative z-10 px-8 pb-10 flex-grow">
                  <p className="text-muted-foreground font-sans leading-relaxed text-base">
                    {step.description}
                  </p>
                </CardContent>
              </Card>)}
          </div>
        </div>
      </div>
    </section>;
}